"use client";

import Header from "@/components/Footer/Header";
import FooterFooter from "@/components/Footer/Footer";
import { useFooterMessages } from "@/i18n/hooks/useFooterMessages";

const StaticSecondaryLinks = () => {
  const m = useFooterMessages();

  const staticFooterData = {
    edx: {
      label: "edx",
      childItems: {
        nodes: [
          { label: m.about, url: "/about-us", id: "about" },
          { label: m.edxForBusiness, url: "/business", id: "edxForBusiness" },
          { label: m.affiliates, url: "/affiliate-program", id: "affiliates" },
          { label: m.openEdx, url: "https://openedx.org/", id: "openEdx" },
          { label: m.careers, url: "/careers", id: "careers" },
          { label: m.news, url: "/news-announcements", id: "news" },
        ],
      },
    },
    connect: {
      label: m.sectionConnect,
      childItems: {
        nodes: [
          { label: m.ideaHub, url: "/resources", id: "ideaHub" },
          {
            label: m.contactUs,
            url: "https://courses.edx.org/support/contact_us",
            id: "contactUs",
          },
          {
            label: m.helpCenter,
            url: "https://support.edx.org/",
            id: "helpCenter",
          },
          { label: m.security, url: "/policy/security", id: "security" },
          { label: m.mediaKit, url: "/media-kit", id: "mediaKit" },
        ],
      },
    },
    legal: {
      label: m.sectionLegal,
      childItems: {
        nodes: [
          {
            label: m.termsOfService,
            url: "/edx-terms-service",
            id: "termsOfService",
          },
          {
            label: m.privacyPolicy,
            url: "/edx-privacy-policy",
            id: "privacyPolicy",
          },
          {
            label: m.cookiePolicy,
            url: "/edx-privacy-policy/cookies",
            id: "cookiePolicy",
          },
          {
            label: m.accessibilityPolicy,
            url: "/accessibility",
            id: "accessibilityPolicy",
          },
          {
            label: m.trademarkPolicy,
            url: "/trademarks",
            id: "trademarkPolicy",
          },
          {
            label: m.modernSlavery,
            url: "/modern-slavery-statement",
            id: "modernSlavery",
          },
          { label: m.sitemap, url: "/sitemap", id: "sitemap" },
          {
            label: m.yourPrivacyChoices,
            url: "#",
            id: "yourPrivacyChoices",
          },
        ],
      },
    },
  };

  return (
    <div className="flex flex-wrap justify-between">
      <div className="mr-12 mb-6">
        <span className="text-base text-left pb-6 mt-0 font-bold">
          {staticFooterData.edx.label}
        </span>
        <ul className="my-6 list-none">
          {staticFooterData.edx.childItems.nodes.map((link) => (
            <li key={link.id} className="mb-2 hover:underline text-base">
              <a className="text-white hover:text-white" href={link.url}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="mr-12 mb-6">
        <span className="text-base text-left pb-6 mt-0 font-bold">
          {staticFooterData.connect.label}
        </span>
        <ul className="my-6 list-none">
          {staticFooterData.connect.childItems.nodes.map((link) => (
            <li key={link.id} className="mb-2 hover:underline text-base">
              <a className="text-white hover:text-white" href={link.url}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="mb-6 grow">
        <span className="text-base text-left pb-6 mt-0 font-bold">
          {staticFooterData.legal.label}
        </span>
        <ul className="my-6 list-none">
          {staticFooterData.legal.childItems.nodes.map((link) => (
            <li key={link.id} className="mb-2 hover:underline text-base">
              {link.id === "yourPrivacyChoices" ? (
                <a
                  className="text-white hover:text-white"
                  href={link.url}
                  onClick={(e) => {
                    e.preventDefault();
                    if (
                      typeof window !== "undefined" &&
                      (window as any).OneTrust
                    ) {
                      (window as any).OneTrust.ToggleInfoDisplay();
                    }
                  }}
                >
                  {link.label}
                </a>
              ) : (
                <a className="text-white hover:text-white" href={link.url}>
                  {link.label}
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default function StaticFooter() {
  return (
    <div className="bg-primary text-primary-foreground pt-16">
      <footer className="flex justify-between max-w-screen-xl mx-auto px-4 pb-4">
        <div className="flex flex-col w-full">
          <Header />
          <StaticSecondaryLinks />
          <FooterFooter />
        </div>
      </footer>
    </div>
  );
}
